import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const en: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    MINI_HEADER_BACK_LABEL: 'Back to payroll types',

    EMPTY_NO_ACCESS_TITLE: "You don't have access to this screen",
    EMPTY_NO_ACCESS_DESCRIPTION:
      'Editing the concept package is a Crehana staff action.',

    ERROR_TITLE: "We couldn't load this screen",
    ERROR_RETRY_BUTTON: 'Retry',

    BUTTON_CANCEL: 'Cancel',

    EMPTY_CONCEPT_NOT_FOUND_TITLE: "This payroll type doesn't exist",
    EMPTY_CONCEPT_NOT_FOUND_DESCRIPTION:
      'It may have been deleted, or the link may be malformed.',
    EMPTY_CONCEPT_NOT_FOUND_ACTION: 'Back to payroll types',

    COL_CODE: 'Code',
    COL_NAME: 'Name',
    COL_ACTIONS: 'Actions',
    TABLE_TITLE: 'Package concepts',
    EMPTY_PACKAGE_TITLE: 'This payroll type has no concepts yet',
    EMPTY_PACKAGE_DESCRIPTION:
      'Add concepts from the catalog so this payroll type can calculate.',
    TOOLTIP_REMOVE_CONCEPT: 'Remove from package',

    COL_ASSIGNMENT_TYPE: 'Assignment type',
    COL_ASSIGNMENT_ACTIVE: 'Assignment active',
    ASSIGNMENT_TYPE_ALWAYS: 'Always',
    ASSIGNMENT_TYPE_ALWAYS_HINT: 'The engine calculates it for everyone.',
    ASSIGNMENT_TYPE_CONDITIONAL: 'Conditional',
    ASSIGNMENT_TYPE_CONDITIONAL_HINT: 'Only if an incidence triggers it.',
    ASSIGNMENT_TYPE_OPTIONAL: 'Optional',
    ASSIGNMENT_TYPE_OPTIONAL_HINT: 'Only via manual admin entry.',

    TWO_FLAGS_TITLE: 'Two conditions, not one',
    TWO_FLAGS_BODY:
      'A concept only calculates if it is active in the catalog AND its assignment is active. Both are required.',
    CATALOG_ACTIVE: 'Active in catalog',
    CATALOG_INACTIVE: 'Inactive in catalog',
    CALC_YES: 'Calculates',
    CALC_NO: "Doesn't calculate",
    CALC_YES_HINT:
      'The concept is active in the catalog and its assignment is active.',
    CALC_NO_CATALOG_HINT:
      'It is assigned and active, but the concept is inactive in the catalog.',
    CALC_NO_ASSIGNMENT_HINT:
      'The concept is active in the catalog, but this assignment is inactive.',
    CALC_NO_BOTH_HINT:
      'The concept is inactive in the catalog, and so is the assignment.',
    CALC_UNKNOWN_HINT:
      "We couldn't confirm this concept's status in the catalog (truncated index).",
    COL_CATALOG_ACTIVE: 'Active in catalog (read-only)',
    COL_CALCULATES: 'Calculates',

    PICKER_LABEL: 'Add concept',
    PICKER_PLACEHOLDER: 'Select concepts from the catalog',
    PICKER_ADD_BUTTON: 'Add',
    PICKER_SELECT_ALL_VISIBLE: 'Select all ({{count}})',
    PICKER_NO_RESULTS: "We couldn't find concepts with that code or name",
    CATALOG_TRUNCATED:
      "This organization's catalog exceeds what we can show here. Contact support before adding more concepts.",

    BUTTON_SAVE: 'Save changes',
    SAVE_ERROR_TITLE: "We couldn't save the package",
    SAVE_UNEXPECTED_ERROR: "We couldn't save the package. Please try again.",
    TOAST_SAVED: 'Concept package saved',
    DISCARD_DIALOG_TITLE: 'Discard unsaved changes?',
    DISCARD_DIALOG_BODY: "You'll lose the changes you made to this package.",
    DISCARD_DIALOG_CONFIRM: 'Discard',
  },
};
